import type { Theme, ThemeFragmentFragment } from 'src/generated/graphql-manager';

import { makeVar } from '@apollo/client';

export type ThemePreviewState = {
  themeId: string;
  overrides?: {
    name?: string;
    mode?: Theme;
    fonts?: ThemeFragmentFragment['fonts'];
    appearanceColors?: ThemeFragmentFragment['appearanceColors'];
  };
};

/**
 * This is a global Apollo variable that stores the theme that is currently being previewed on the branding page.
 * It lets different UI elements update it and make changes visible in real time without the need for prop-drilling or the usage of context.
 */
export const themePreviewVar = makeVar<ThemePreviewState | undefined>(undefined);
